import { FontPairing } from 'constants/fontPairings'
import { PALETTES } from 'constants/palettes'
import { getBrandKitFontPairing } from 'hooks/queries/brandKits/getBrandKitFontPairing'
import { shuffle } from 'lodash'
import { useCallback, useState } from 'react'
import { BrandKit } from 'types'

export interface ColorPaletteState {
  websitePalette: string[]
  generatedPalettes: string[][]
  selectedPaletteIndex: number
}

export interface FontPairingState {
  websitePairing: FontPairing | null
}

export function useBrandKitState() {
  const [colorPaletteState, setColorPaletteState] = useState<ColorPaletteState>({
    websitePalette: [],
    generatedPalettes: [],
    selectedPaletteIndex: 0,
  })

  const [fontPairingState, setFontPairingState] = useState<FontPairingState>({
    websitePairing: null,
  })

  const initFromBrandKit = useCallback((brandKit: BrandKit) => {
    // Initialize color palette state
    if (brandKit?.brand_visual_kit?.primary_color_palette?.colors) {
      const websitePalette = brandKit.brand_visual_kit.primary_color_palette.colors.map((color) => color.hex) || []
      const generatedPalettes = shuffle([...PALETTES]).slice(0, 3)

      setColorPaletteState({
        websitePalette,
        generatedPalettes,
        selectedPaletteIndex: 0,
      })
    }

    // Initialize font pairing state
    if (brandKit?.brand_visual_kit?.text_styles) {
      const websitePairing = getBrandKitFontPairing(brandKit.brand_visual_kit)

      setFontPairingState({
        websitePairing: websitePairing || null,
      })
    }
  }, [])

  return {
    colorPaletteState,
    setColorPaletteState,
    fontPairingState,
    setFontPairingState,
    initFromBrandKit,
  }
}
